export default __webpack_public_path__ + "static/media/BerlinTypeWeb-Bold.2b1bd6d0.eot";